module.exports = __webpack_public_path__ + "static/media/master-card-logo.946cb952.svg";